import { pageURLs } from "@/constants";
import { WANT_AD_KEY } from "@/constants/common";
import { setLocalStorage } from "@/helpers/common";

export const wantListingPath = ({ id, slug } = {}) => `${pageURLs.wantAdDetails}/${slug || id}`;

export const openWantListing = (navigate, { id, slug } = {}) => {
  setLocalStorage(WANT_AD_KEY, { wantAdId: id, introId: 1 });
  navigate(wantListingPath({ id, slug }));
};

export const wantListingLinkProps = (navigate, listing) => ({
  href: wantListingPath(listing),
  onClick: (event) => {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.button === 1) return;
    event.preventDefault();
    openWantListing(navigate, listing);
  },
});
